<!-- 
    模板页
    lovi 2019-5-28
-->
<template>
  <div>
    <div class="w-1200 template">
      <left-nav :navList="navList"></left-nav>
      <div class="right-sidebar">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from "@/components/common/leftNav";
export default {
  name: "personal",
  components: {
    LeftNav
  },
  data() {
    return {
      navList: [
        {
          path: "/personal/userInfo",
          icon: "icon-personal",
          name: this.$t("personal.personalInformation")
        },
        {
          path: "/personal/msgCenter",
          icon: "icon-msgCenter",
          name: this.$t("personal.messageCenter")
        },
        {
          path: "/personal/bill",
          icon: "icon-bill",
          name: this.$t("wallet.billDetail")
        }
      ]
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.template {
  display: flex;
  justify-content: space-between;
  .right-sidebar {
    flex: 1;
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    min-height: calc(100vh - 100px - 20px);
    overflow: hidden;
  }
}
</style>
